import React from 'react';

/**
 * Confirmation Modal Component
 * Displays a confirmation dialog with customizable type (danger, warning, success)
 */
const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title, 
  message, 
  confirmText = 'Confirmer', 
  cancelText = 'Annuler', 
  type = 'danger' 
}) => {
  if (!isOpen) return null;

  const colors = {
    danger: {
      icon: '⚠️',
      iconColor: '#FF5757',
      confirmBg: 'linear-gradient(135deg, #FF5757 0%, #FF8A8A 100%)',
      confirmShadow: '0 8px 20px rgba(255, 87, 87, 0.4)'
    },
    warning: {
      icon: '⚠️',
      iconColor: '#FFC107',
      confirmBg: 'linear-gradient(135deg, #FFC107 0%, #FFD54F 100%)',
      confirmShadow: '0 8px 20px rgba(255, 193, 7, 0.4)'
    },
    success: {
      icon: '✅',
      iconColor: '#00C2FF',
      confirmBg: 'linear-gradient(135deg, #00C2FF 0%, #4A5BFF 100%)',
      confirmShadow: '0 8px 20px rgba(0, 194, 255, 0.4)'
    }
  };

  const currentColors = colors[type] || colors.danger;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
        backdropFilter: 'blur(4px)'
      }}
      onClick={onClose}
      data-testid="confirmation-modal"
    >
      <div 
        style={{
          background: 'linear-gradient(135deg, #1A1E2E 0%, #242A3D 100%)',
          borderRadius: '16px',
          padding: '32px',
          maxWidth: '480px',
          width: '90%',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5), 0 0 1px rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          animation: 'slideIn 0.3s ease-out'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <div 
            style={{
              fontSize: '48px',
              marginBottom: '16px',
              filter: 'drop-shadow(0 0 10px currentColor)',
              color: currentColors.iconColor
            }}
          >
            {currentColors.icon}
          </div>
          <h3 
            style={{
              fontSize: '24px',
              fontWeight: '700',
              color: '#FFFFFF',
              marginBottom: '12px',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.3)'
            }}
            data-testid="confirmation-modal-title"
          >
            {title}
          </h3>
          <p 
            style={{
              fontSize: '16px',
              color: '#8A92B2',
              lineHeight: '1.6'
            }}
            data-testid="confirmation-modal-message"
          >
            {message}
          </p>
        </div>

        <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
          <button
            onClick={onClose}
            style={{
              flex: 1,
              padding: '14px 24px',
              borderRadius: '12px',
              border: '2px solid #3A4359',
              background: 'transparent',
              color: '#8A92B2',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              textTransform: 'uppercase',
              letterSpacing: '0.5px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = '#4A5BFF';
              e.currentTarget.style.color = '#FFFFFF';
              e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = '#3A4359';
              e.currentTarget.style.color = '#8A92B2';
              e.currentTarget.style.transform = 'translateY(0)';
            }}
            data-testid="confirmation-modal-cancel-btn"
          >
            {cancelText}
          </button>
          <button
            onClick={() => {
              onConfirm();
              onClose();
            }}
            style={{
              flex: 1,
              padding: '14px 24px',
              borderRadius: '12px',
              border: 'none',
              background: currentColors.confirmBg,
              color: type === 'warning' ? '#1A1E2E' : '#FFFFFF',
              fontSize: '16px',
              fontWeight: '700',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = currentColors.confirmShadow;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '';
            }}
            data-testid="confirmation-modal-confirm-btn"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
